import React from 'react'
import { cn } from '../../lib/utils'
import type { ContainerSize, BaseComponentProps } from '../../types'

export interface ContainerProps extends BaseComponentProps {
  size?: ContainerSize
  centered?: boolean
  padding?: 'none' | 'sm' | 'md' | 'lg' | 'xl'
}

const sizeClasses: Record<ContainerSize, string> = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  xl: 'max-w-[1400px]',
  '2xl': 'max-w-[1600px]',
  full: 'max-w-full',
}

const paddingClasses = {
  none: 'px-0',
  sm: 'px-4',
  md: 'px-6 lg:px-8',
  lg: 'px-8 lg:px-12',
  xl: 'px-12 lg:px-16',
}

export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  (
    {
      children,
      size = 'xl',
      centered = true,
      padding = 'md',
      className,
      ...props
    },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'w-full',
          sizeClasses[size],
          centered && 'mx-auto',
          paddingClasses[padding],
          className
        )}
        {...props}
      >
        {children}
      </div>
    )
  }
)

Container.displayName = 'Container'
